module.exports = __webpack_public_path__ + "9aa0793f3beef577f120cadf5324c953.svg";